// src/component/sharedComponents/ProtectedRoute.jsx
import { useState } from "react";
import ApiService from "../../utils/api";

const api = new ApiService();

const ProtectedRoute = ({ children }) => {
  const [authorized, setAuthorized] = useState(sessionStorage.getItem("feed_access") === "true");

  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post("/product/passwordPage", { password });
      
      if (response.status === 200 || response.status === 201) {
        sessionStorage.setItem("feed_access", "true");
        setAuthorized(true);
      } else {
        alert("كلمة المرور غير صحيحة");
      }
    } catch (error) {
      alert("كلمة المرور غير صحيحة");
    }
  };

  if (authorized) return children;

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center", background: "linear-gradient(135deg, #f8f5ff 0%, #ede7ff 50%, #ffffff 100%)", fontFamily: "Cairo, sans-serif", padding: "20px" }}>
      <div style={{ width: "100%", maxWidth: "420px", background: "#fff", borderRadius: "24px", padding: "40px 35px", boxShadow: "0 20px 50px rgba(124,58,237,.18)", textAlign: "center", border: "1px solid #eee" }}>
        <div style={{ width: "85px", height: "85px", borderRadius: "50%", background: "#f3e8ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "38px", margin: "0 auto 20px" }}>🔒</div>

        <h2 style={{ margin: 0, color: "#6d28d9", fontSize: "28px", fontWeight: "700" }}>صفحة محمية</h2>

        <p style={{ color: "#666", marginTop: "12px", marginBottom: "30px", lineHeight: 1.7 }}>
          أدخل كلمة المرور للوصول إلى صفحة
          <br />
          أسعار الخامات والأعلاف
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ position: "relative", marginBottom: "20px" }}>
            <span style={{ position: "absolute", left: "16px", top: "50%", transform: "translateY(-50%)", fontSize: "18px", color: "#8b5cf6", pointerEvents: "none" }}>🔒</span>

            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="كلمة المرور"
              dir="rtl"
              style={{ width: "100%", padding: "15px 50px 15px 15px", border: "2px solid #e9d5ff", borderRadius: "14px", outline: "none", fontSize: "16px", boxSizing: "border-box", textAlign: "right", transition: "all .3s" }}
              onFocus={(e) => {
                e.target.style.borderColor = "#8b5cf6";
                e.target.style.boxShadow = "0 0 0 4px rgba(139,92,246,.15)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#e9d5ff";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "15px",
              border: "none",
              borderRadius: "14px",
              background: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
              transition: "all .3s",
              boxShadow: "0 10px 25px rgba(109,40,217,.3)"
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            دخول
          </button>
        </form>

        <div style={{ marginTop: "25px", color: "#999", fontSize: "13px" }}>🔐 الوصول متاح للمصرح لهم فقط</div>
      </div>
    </div>
  );
};

export default ProtectedRoute;
